const React = require('react')
const { createRef } = React
const { Editor } = require('@toast-ui/react-editor')
import { sanitize } from 'dompurify'

const sanitiseHtml = str => {
  return sanitize(
    str?.replaceAll(
      /(<iframe[^>]*>)[\s\S]*?(<\/iframe>)/g,
      (match, opentag, closetag) => `${opentag.replaceAll(/<=""/g, '')}${closetag}`
    ),
    { ALLOWED_TAGS: ['iframe'] }
  )
}

const Input = props => {
  const ref = createRef()
  if (props.type == 'plaintext')
    return (
      <div className={`input-wrapper md`}>
        {props.label ? (
          <p>
            <small>
              <strong>{props.label}</strong>
            </small>
          </p>
        ) : null}
        <textarea
          {...Object.fromEntries(
            Object.entries(props).filter(
              ([key, value]) =>
                (!key.startsWith('on', 0) && key !== 'children') || (key != 'defaultValue' && value?.length > 0)
            )
          )}
          style={{ height: props.height ?? '200px', width: props.width ?? '500px' }}
          readOnly={props.readOnly ?? false}
          onChange={e => props.onChange(e)}
          onWheel={e => e.target.blur()}
        />
      </div>
    )
  if (props.type == 'textarea')
    return (
      <div className={`input-wrapper md`}>
        {props.label ? (
          <p>
            <small>
              <strong>{props.label}</strong>
            </small>
          </p>
        ) : null}
        <Editor
          autofocus={props.autofocus ?? false}
          initialValue={sanitiseHtml(props.defaultValue?.split('\\n').join(`\n`))}
          previewStyle='tab'
          height={props.height ?? '400px'}
          initialEditType='wysiwyg'
          useCommandShortcut={true}
          usageStatistics={false}
          onChange={e => {
            if (props.onChange)
              props.onChange({
                preventDefault: () => {},
                target: {
                  value: ref.current.editorInst.getMarkdown()
                }
              })
          }}
          ref={ref}
          customHTMLSanitizer={sanitiseHtml}
          customHTMLRenderer={{
            htmlBlock: {
              iframe(node) {
                return [
                  { type: 'openTag', tagName: 'iframe', outerNewLine: true, attributes: node.attrs },
                  { type: 'html', content: node.childrenHTML },
                  { type: 'closeTag', tagName: 'iframe', outerNewLine: true }
                ]
              }
            }
          }}
        />
      </div>
    )
  else
    return (
      <div className={`input-wrapper ${props.valid ? props.valid : ''}`}>
        {props.label ? (
          <p>
            <small>
              <strong>{props.label}</strong>
            </small>
          </p>
        ) : null}
        <input
          {...Object.fromEntries(
            Object.entries(props).filter(
              ([key, value]) =>
                (!key.startsWith('on', 0) && key !== 'children') || (key != 'defaultValue' && value?.length > 0)
            )
          )}
          readOnly={props.readOnly ?? false}
          onChange={e => props.onChange(e)}
          onWheel={e => e.target.blur()}
        />
      </div>
    )
}

module.exports = Input
